import styled from 'styled-components'
import { cyberColors } from '../../lib/colors'

interface seed_style_props {
  copyCursor?: boolean
  height?: string
  background?: string
  size?: string
  color?: string
  padding?: string
  marginBottom?: string
}
interface main_style_props {
  margin?: string
}
export const Wrapper = styled.div`
  padding: 5px;
`

export const Main = styled.main<main_style_props>`
  overflow-x: hidden;
  overflow-y: scroll;
  margin: ${({ margin }) => margin || '20px 0'};
  height: 540px;
  transition: all 0.333s linear;
`
export const Title = styled.div`
  color: ${cyberColors.whiteText};
  font-size: 28px;
  text-transform: uppercase;
  margin: 30px 0 20px;
`
export const SeedBox = styled.div<seed_style_props>`
  background: ${({ background }) => background || cyberColors.greyDark};
  padding: ${({ padding }) => padding || '10px'};
  border-radius: 4px;
  transition: all 0.333s linear;
  .nonce {
    height: ${({ height }) => height || '14px'};
  }
  p {
    font-size: ${({ size }) => size || '12px'};
    text-transform: uppercase;
    color: ${cyberColors.greyText};
    margin-bottom: ${({ marginBottom }) => marginBottom || '5px'};
  }
  textarea {
    background: transparent;
    font-family: 'Regular';
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 ${({ color }) => color || '#c4c9dd'};
    font-size: ${({ size }) => size || '18px'};
    margin: auto;
    appearance: none;
    width: 100%;
    max-width: 500px;
    height: ${({ height }) => height};
    resize: none;
    user-select: text !important;
    cursor: ${({ copyCursor }) => (copyCursor ? 'copy' : 'auto')};
    line-height: 1;
    scrollbar-width: none;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`
